// "Release date" sort for the search page. See snippets/glg-release-sort.liquid.
//
// facets.js normally re-renders the results in place, but it can only pass a
// sort_by, and Shopify drops sort_by values it doesn't know. So whenever the
// release sort is involved (choosing it, or changing anything while it's
// active) we take over the form change and do a full page load instead,
// switching the search template with ?view=release.
(function () {
  const RELEASE_VALUE = 'release-date';
  const SINGLE_VALUE_KEYS = ['q', 'options[prefix]', 'type', 'sort_by'];

  const currentParams = new URLSearchParams(window.location.search);
  const onReleaseView = currentParams.get('view') === 'release';

  function collectParams(target) {
    const form = target.closest('form');
    const forms =
      form.id === 'FacetFiltersFormMobile'
        ? [form]
        : ['FacetSortForm', 'FacetFiltersForm', 'FacetSortDrawerForm']
            .map((id) => document.getElementById(id))
            .filter(Boolean);

    const params = new URLSearchParams();
    forms.forEach((f) => {
      new FormData(f).forEach((value, key) => {
        if (SINGLE_VALUE_KEYS.includes(key)) params.set(key, value);
        else params.append(key, value);
      });
    });
    if (target.name === 'sort_by') params.set('sort_by', target.value);
    return params;
  }

  document.addEventListener(
    'input',
    (event) => {
      const target = event.target;
      if (!target.closest || !target.closest('facet-filters-form form')) return;

      const choosingRelease = target.name === 'sort_by' && target.value === RELEASE_VALUE;
      if (!choosingRelease && !onReleaseView) return;

      // Keep facets.js from also handling this change.
      event.stopImmediatePropagation();

      const params = collectParams(target);
      if (params.get('sort_by') === RELEASE_VALUE) {
        params.delete('sort_by');
        params.set('view', 'release');
      } else {
        params.delete('view');
      }
      window.location.assign(`${window.location.pathname}?${params.toString()}`);
    },
    true,
  );
})();
